import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { StorageAccountLegacy } from 'mbs-ui-shared@models/StorageAccount';

interface StorageAccountsState {
  entities: Record<string, StorageAccountLegacy>;
  ids: string[];
  loading: boolean;
  loaded: boolean;
}

const initialState: StorageAccountsState = {
  entities: {},
  ids: [],
  loading: false,
  loaded: false
};

export const StorageAccountsStore = signalStore(
  { providedIn: 'root' },
  withDevtools('StorageAccountsStore'),
  withState<StorageAccountsState>(initialState),
  withComputed((store) => ({
    all: computed(() =>
      store
        .ids()
        .map((id) => store.entities()[id])
        .filter(Boolean)
    )
  })),
  withMethods((store) => ({
    setLoading(loading: boolean): void {
      patchState(store, { loading });
    },
    setAll(accounts: StorageAccountLegacy[]): void {
      const entities: Record<string, StorageAccountLegacy> = {};
      const ids: string[] = [];
      for (const account of accounts) {
        const id = account.Id;
        entities[id] = account;
        ids.push(id);
      }
      patchState(store, { entities, ids, loaded: true, loading: false });
    }
  }))
);

export type StorageAccountsStoreType = InstanceType<typeof StorageAccountsStore>;
